module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-bottom-stone-path-remnants.34e18fbb.png";